import type {
	DBSchema,
	IDBPDatabase,
	StoreKey,
	StoreNames,
	StoreValue,
} from "idb";
import type { IdentityStorageKey } from "../user/device";

export const DB_NAME = "OpenSignerFrameDB";
export const DB_VERSION = 1; // bump when we add new stores/indexes

export const ENCRYPTION_KEYS_STORE_NAME = "IdentityKeysStore";
export const ALL_STORES = [ENCRYPTION_KEYS_STORE_NAME] as const;

export interface OpenFrameIDBSchema extends DBSchema {
	[ENCRYPTION_KEYS_STORE_NAME]: {
		key: IdentityStorageKey;
		value: CryptoKeyPair;
	};
}

export type OpenFrameIDB = IDBPDatabase<OpenFrameIDBSchema>;
export type OpenFrameStore = StoreNames<OpenFrameIDBSchema>;
export type OpenFrameStoreKey<S extends OpenFrameStore> = StoreKey<
	OpenFrameIDBSchema,
	S
>;
export type OpenFrameStoreValue<S extends OpenFrameStore> = StoreValue<
	OpenFrameIDBSchema,
	S
>;

export type Migration = (db: OpenFrameIDB, oldVersion: number) => void;
export const MIGRATIONS: Record<number, Migration> = {
	1: (db, _oldVersion) => {
		for (const storeName of ALL_STORES) {
			if (!db.objectStoreNames.contains(storeName)) {
				db.createObjectStore(storeName);
			}
		}
	},
};
